'use es6';

import { HELPDESK } from 'FormsUI/constants/WorkspaceFlags';
import { isUngatedForLimitedTicketFunctionalityInInbox } from 'FormsUI/selectors/Gates';
import { INBOX_TYPES } from 'FormsUI/constants/Ticket';
export const getInboxes = state => {
  const {
    inboxes: {
      inboxes: {
        value
      }
    }
  } = state;
  const isPortalCreatedAfterApril2024 = isUngatedForLimitedTicketFunctionalityInInbox(state);
  /**
   * If the portal was created after April 2024, we don't want to show the "Inbox" option
   * because users cannot create or manage tickets in the inbox.
   */
  return value.filter(inbox => !isPortalCreatedAfterApril2024 || isPortalCreatedAfterApril2024 && inbox.name !== INBOX_TYPES.inbox);
};
export const getCurrentInboxName = ({
  inboxes: {
    current: {
      value: {
        name
      }
    }
  }
}) => name;
export const getCurrentInboxId = state => {
  const {
    inboxes: {
      current: {
        value: {
          id,
          name
        }
      }
    }
  } = state;
  const isPortalCreatedAfterApril2024 = isUngatedForLimitedTicketFunctionalityInInbox(state);
  /**
   * If the current inbox/help desk is the "Inbox" type and the portal was created after April 2024, we don't want to return the inbox id
   * because users cannot create or manage tickets in the inbox.
   */
  return isPortalCreatedAfterApril2024 && name === INBOX_TYPES.inbox ? null : id;
};
export const getIsCurrentInboxLoading = ({
  inboxes: {
    current: {
      requested
    }
  }
}) => requested;
export const getCurrentOrFirstInboxId = state => {
  const inboxes = getInboxes(state);
  const currentInboxId = getCurrentInboxId(state);
  return currentInboxId || (inboxes.length === 1 ? inboxes[0].id : null);
};
export const getFirstInboxIdOnly = state => {
  const inboxes = getInboxes(state);
  return inboxes.length === 1 ? inboxes[0].id : null;
};
export const getIsCurrentInboxHelpdesk = state => {
  const inboxes = getInboxes(state);
  const currentInboxId = getCurrentInboxId(state);
  const helpdeskInbox = inboxes.find(inbox => inbox.workspaceFlag === HELPDESK);
  return helpdeskInbox ? currentInboxId === helpdeskInbox.id : false;
};
export const getIsCurrentInboxHelpdeskByInboxId = (state, inboxId) => {
  const inboxes = getInboxes(state);
  const helpdeskInbox = inboxes.find(inbox => inbox.workspaceFlag === HELPDESK);
  return helpdeskInbox ? helpdeskInbox.id === inboxId : false;
};
export const getInboxesRequestSuccess = ({
  inboxes: {
    inboxes: {
      requestSuccess
    }
  }
}) => requestSuccess;